import { Grid } from '@mui/material'
import { Workflow, WorkflowListItem } from 'features/workflows/types'
import WorkflowCard from 'features/workflows/ui/Gallery/WorkflowCard'

export function HomeDynamicWorkflows({ workflows }: { workflows: Workflow[] }) {
  const handleWorkflowClick = (workflow: Workflow) => {
    const url = `/workflows/${workflow.id}`
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <>
      {workflows.map((workflow) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={workflow.id}>
          <WorkflowCard onClick={() => handleWorkflowClick(workflow)} workflow={workflow as WorkflowListItem} />
        </Grid>
      ))}
    </>
  )
}

export default HomeDynamicWorkflows
